import { Navigate, Outlet } from "react-router";
import { useAdminAuth } from "../context/admin-auth";

export function RequireAdmin() {
	const { adminUser, loading } = useAdminAuth();

	if (loading) return null;
	if (!adminUser) return <Navigate to="/admin/sign-in" replace />;
	return <Outlet />;
}
